<template>
  <div>
    <dashboard-alert
      v-for="(alert, index) in alerts"
      :key="index"
      :variant="alert.color.toLowerCase()"
      :title="alert.title"
      :description="alert.text"
    />
    <p v-if="loading">
      <b-spinner label="Loading..." />
    </p>
    <div v-if="description && !loading">
      <p v-html="description" />
    </div>
  </div>
</template>

<script>
import DescriptionApis from '@/services/apis/description'
import DashboardAlert from '../dashboard/dashboardAlert.vue'

const description = new DescriptionApis()
export default {
  components: {
    DashboardAlert,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      description: null,
      loading: false,
      alerts: [],
    }
  },
  watch: {
    '$store.state.appConfig.layout.isRTL': {
      handler() {
        this.getDescriptions()
      },
    },
  },
  async created() {
    await this.getDescriptions()
  },
  methods: {
    async getDescriptions() {
      this.loading = true
      const { name } = this.$props
      await description.get({ name }).then(res => {
        try {
          const parsedValue = JSON.parse(res.data.results.value)
          this.description = parsedValue.value
          this.alerts = parsedValue.alertTexts
        } catch (error) {
          this.description = res.data.results.value
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

<style scoped>
/* Add your styles here */
</style>
